function getShippingAddress(_this, username) {
  _this.pageData.listShippingAddress = []
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/getShippingAddress',
      url: Vue.prototype.api + 'api/local/getShippingAddress',
      data: {
        username,
      },
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          _this.pageData.listShippingAddress = response.data.data

          return
        } else if (response.data.code == '210') {
          return
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

function returnPromiseShippings(_this, username) {
  return new Promise((resolve, reject) => {
    _this
      .$axios({
        method: 'post',
        url: Vue.prototype.api + 'api/local/getShippingAddress',
        // url: Vue.prototype.api + '6003/api/local/getShippingAddress',
        data: {
          username,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.code == '200') {
            resolve(response.data.data)
          } else if (response.data.code == '210') {
            resolve([])
          } else {
            _this.$notify.error({
              title: _this.$t('App.notify.title_server'),
              message: _this.$t('App.notify.content_servererr'),
            })
            return
          }
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_server') + response.status,
          })
          return
        }
      })
      .catch((error) => {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_servererr'),
        })
        return
      })
  })
}

function returnPromiseReceipts(_this, username) {
  return new Promise((resolve, reject) => {
    _this
      .$axios({
        method: 'post',
        // url: Vue.prototype.api + '6003/api/local/getReceiptAddress',
        url: Vue.prototype.api + 'api/local/getReceiptAddress',
        data: {
          username,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.code == '200') {
            resolve(response.data.data)
          } else if (response.data.code == '210') {
            resolve([])
          } else {
            _this.$notify.error({
              title: _this.$t('App.notify.title_server'),
              message: _this.$t('App.notify.content_servererr'),
            })
            return
          }
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_server') + response.status,
          })
          return
        }
      })
      .catch((error) => {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_servererr'),
        })
        return
      })
  })
}

function getReceiptAddress(_this, username) {
  _this.pageData.listReceiptAddress = []
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/getReceiptAddress',
      url: Vue.prototype.api + 'api/local/getReceiptAddress',
      data: {
        username,
      },
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          _this.pageData.listReceiptAddress = response.data.data

          return
        } else if (response.data.code == '210') {
          return
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

function addShippingAddress(_this, shippingaddress) {
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/addShippingAddress',
      url: Vue.prototype.api + 'api/local/addShippingAddress',
      data: {
        username: shippingaddress.username,
        contacts: shippingaddress.contacts,
        country: shippingaddress.country,
        province: shippingaddress.province,
        city: shippingaddress.city,
        zipcode: shippingaddress.zipcode,
        address: shippingaddress.address,
        tel: shippingaddress.tel,
        email: shippingaddress.email,
        tag: shippingaddress.tag,
      },
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          let newAdd = response.data.data
          for (let item of _this.pageData.listCountry) {
            if (item.id === newAdd.country) {
              newAdd.country = item.name_en
            }
          }
          _this.pageData.listShippingAddress.push(newAdd)
          _this.shown.newaddshow = false
          _this.pageData.newAdd.country = ''
          _this.pageData.newAdd.province = ''
          _this.pageData.newAdd.city = ''
          _this.pageData.newAdd.zipcode = ''
          _this.pageData.newAdd.address = ''
          _this.pageData.newAdd.tel = ''
          _this.pageData.newAdd.contacts = ''
          _this.pageData.newAdd.email = ''
          _this.pageData.newAdd.tag = ''
        } else if (response.data.code == '290') {
          _this.$notify.error({
            title: _this.$t('App.page.orderconfirm.notify_warn'),
            message: _this.$t('App.page.orderconfirm.notify_full_address_java'),
          })
          return
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

function addReceiptAddress(_this, receiptaddress) {
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/addReceiptAddress',
      url: Vue.prototype.api + 'api/local/addReceiptAddress',
      data: {
        username: receiptaddress.username,
        company: receiptaddress.company,
        contacts: receiptaddress.contacts,
        country: receiptaddress.country,
        province: receiptaddress.province,
        city: receiptaddress.city,
        zipcode: receiptaddress.zipcode,
        address: receiptaddress.address,
        tel: receiptaddress.tel,
        email: receiptaddress.email,
        taxno: receiptaddress.taxno,
        tag: receiptaddress.tag,
      },
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          let newAdd = response.data.data
          for (let item of _this.pageData.listCountry) {
            if (item.id === newAdd.country) {
              newAdd.country = item.name_en
            }
          }
          _this.pageData.listReceiptAddress.push(newAdd)
          _this.shown.newaddshow_receipt = false
          _this.pageData.newAdd_receipt.country = ''
          _this.pageData.newAdd_receipt.province = ''
          _this.pageData.newAdd_receipt.city = ''
          _this.pageData.newAdd_receipt.zipcode = ''
          _this.pageData.newAdd_receipt.address = ''
          _this.pageData.newAdd_receipt.tel = ''
          _this.pageData.newAdd_receipt.company = ''
          _this.pageData.newAdd_receipt.contacts = ''
          _this.pageData.newAdd_receipt.email = ''
          _this.pageData.newAdd_receipt.taxno = ''
          _this.pageData.newAdd_receipt.tag = ''
        } else if (response.data.code == '290') {
          _this.$notify.error({
            title: _this.$t('App.page.orderconfirm.notify_warn'),
            message: _this.$t('App.page.orderconfirm.notify_full_address_java'),
          })
          return
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

function packDetails(list) {
  return list.map((item) => {
    return {
      product_id: item.productid,
      product_name: item.productname,
      quantity: item.quantity,
      sign: item.sign,
      scount: item.scount,
      subtotal: item.subprice,
      uniprice: item.uniprice,
      weight: item.weight,
      disPrice: item.ladderPrice || item.disprice,
      newPrice: item.new_price,
    }
  })
}

function isEmptyStr(str) {
  if (typeof str == undefined || str == null || str == '') {
    return true
  }
}

function verifyOrder(_this, form) {
  if (isEmptyStr(form.shipping_address)) {
    _this.$notify.warning({
      title: _this.$t('App.notify.title_nofity'),
      message: _this.$t('App.page.orderconfirm.notify_check_shippingaddress'),
    })
    return false
  }
  if (isEmptyStr(form.receipt_address)) {
    _this.$notify.warning({
      title: _this.$t('App.notify.title_nofity'),
      message: _this.$t('App.page.orderconfirm.notify_check_receiptaddress'),
    })
    return false
  }
  if (isEmptyStr(form.delivery_terms)) {
    _this.$notify.warning({
      title: _this.$t('App.notify.title_nofity'),
      message: _this.$t('App.page.orderconfirm.notify_check_deliveryterms'),
    })
    return false
  }
  if (form.listOrderdetails.length == 0) {
    _this.$notify.warning({
      title: _this.$t('App.notify.title_nofity'),
      message: _this.$t('App.page.orderconfirm.notify_check_details'),
    })
    return false
  }
  if (
    _this.formData.orderForm.total < _this.pageData.custUserinfo.minamount ||
    _this.formData.orderForm.totalWeight < _this.pageData.custUserinfo.minweight
  ) {
    _this.$notify.warning({
      title: _this.$t('App.notify.title_nofity'),
      message: _this.$t(
        'App.page.orderconfirm.notify_check_mintotal_minweight'
      ),
    })
    return false
  }
  return true
}

function getModifiedList(_this, orderDetailsList, country) {
  orderDetailsList[0].id = _this.pageData.username
  _this
    .$axios({
      method: 'post',
      url: Vue.prototype.api + 'api/local/getSalePirceByProductId',
      // url: Vue.prototype.api + '6003/api/local/getSalePirceByProductId',
      data: orderDetailsList,
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          let list = response.data.data
          if (list.length == 0) {
            orderSubmit(_this, _this.formData.orderForm, country)
          } else {
            // cartjs.clearCart(_this, _this.pageData.username)
            let names = orderDetailsList
              .filter((it) => list.includes(it.product_id))
              .map((op) => op.product_name)

            _this.$notify.warning({
              title: _this.$t('App.notify.title_nofity'),
              message:
                _this.$t('App.page.orderconfirm.notify_pricemodified') +
                '  ' +
                names.join(','),
            })

            _this.pageData.submitLoad = false
            _this.pageData.fullScreenLoad = false

            return
          }
        } else {
          _this.pageData.submitLoad = false
          _this.pageData.fullScreenLoad = false

          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.pageData.submitLoad = false
        _this.pageData.fullScreenLoad = false

        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.pageData.submitLoad = false
      _this.pageData.fullScreenLoad = false

      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

function quickOrdering(_this, form) {
  return new Promise((resolve, reject) => {
    _this
      .$axios({
        method: 'post',
        // url: Vue.prototype.api + '6003/api/local/orderSubmit',
        url: Vue.prototype.api + 'api/local/orderSubmit',
        data: form,
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.code == '200') {
            if (response.data.data.email == 1) {
              _this.$notify.warning({
                title: _this.$t('App.notify.title_server'),
                message: _this.$t(
                  'App.page.orderconfirm.notify_email_exception'
                ),
                duration: 0,
              })
            }

            resolve(1)
            return
          } else if (response.data.code == '290') {
            _this.$notify.error({
              title: _this.$t('App.notify.title_server'),
              message: _this.$t('App.notify.content_redudancy'),
            })

            resolve(1)
            return
          } else if (response.data.code == '550') {
            _this.$notify.error({
              title: _this.$t('App.notify.title_server'),
              message: _this.$t(
                'App.page.orderconfirm.notify_product_outofselling'
              ),
            })
            resolve(1)
            return
          } else if (response.data.code == '600') {
            _this.$notify.error({
              title: _this.$t('App.notify.title_warning'),
              message: _this.$t('App.notify.content_illegal'),
            })
            resolve(1)
            return
          } else {
            _this.$notify.error({
              title: _this.$t('App.notify.title_server'),
              message: _this.$t('App.notify.content_servererr'),
            })
            resolve(0)
            return
          }
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_server') + response.status,
          })
          resolve(1)
          return
        }
      })
      .catch((error) => {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_servererr'),
        })
        resolve(1)
        return
      })
  })
}

function orderSubmit(_this, form, country) {
  form.oritotal = Number(form.oritotal)
  form.total = Number(form.total)
  form.listOrderdetails.map((it) => {
    let product = _this.pageData.ladderDetailData && _this.pageData.ladderDetailData[it.product_id] || {}
    if (it.newPrice && product.stagedPrice) {
      it.master_pack_qty = product.stagedPriceRule.masterPackQty || null
      it.master_carton_qty = product.stagedPriceRule.masterCartonQty || null
      it.standard_pack_qty = product.standardPackQty || null
    }
  })
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/orderSubmit',
      url: Vue.prototype.api + 'api/local/orderSubmit',
      data: {
        username: _this.pageData.username,
        country_id: country,
        k3custid: _this.pageData.custUserinfo.k3FCustId,
        shippingaddress: form.shipping_address,
        receiptaddress: form.receipt_address,
        delivery_terms: form.delivery_terms,
        sign: form.sign,
        oritotal: form.oritotal,
        total: form.total,
        weight: form.totalWeight,
        cust_po: form.cust_no,
        notes: form.notes,
        creator: _this.pageData.username,
        listOrderdetails: form.listOrderdetails,
        custuser: _this.pageData.custUserinfo,
      },
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          cartjs.clearCart(_this, _this.pageData.username)

          if (response.data.data.email == 1) {
            _this.$notify.warning({
              title: _this.$t('App.notify.title_server'),
              message: _this.$t('App.page.orderconfirm.notify_email_exception'),
              duration: 0,
            })
          }

          setTimeout(() => {
            _this.pageData.submitLoad = false
            _this.pageData.fullScreenLoad = false
            _this.$router.push({
              name: 'Orderform',
              query: {
                orderid: response.data.data.order_id,
              },
            })
          }, 1000)
          return
        } else if (response.data.code == '290') {
          // cartjs.clearCart(_this, _this.pageData.username)
          _this.pageData.submitLoad = false
          _this.pageData.fullScreenLoad = false
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_redudancy'),
          })

          setTimeout(() => {
            return
          }, 1200)
        } else if (response.data.code == '550') {
          setTimeout(() => {
            _this.pageData.submitLoad = false
            _this.pageData.fullScreenLoad = false
            _this.$notify.error({
              title: _this.$t('App.notify.title_server'),
              message: _this.$t(
                'App.page.orderconfirm.notify_product_outofselling'
              ),
            })
            return
          }, 2000)
        } else if (response.data.code == '600') {
          setTimeout(() => {
            _this.pageData.submitLoad = false
            _this.pageData.fullScreenLoad = false
            _this.$notify.error({
              title: _this.$t('App.notify.title_warning'),
              message: _this.$t('App.notify.content_illegal'),
            })
            return
          }, 2000)

          return
        } else {
          setTimeout(() => {
            _this.pageData.submitLoad = false
            _this.pageData.fullScreenLoad = false
            _this.$notify.error({
              title: _this.$t('App.notify.title_server'),
              message: _this.$t('App.notify.content_servererr'),
            })
            return
          }, 2000)
        }
      } else {
        setTimeout(() => {
          _this.pageData.submitLoad = false
          _this.pageData.fullScreenLoad = false
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_server') + response.status,
          })
          return
        }, 2000)
      }
    })
    .catch((error) => {
      console.log(error)

      setTimeout(() => {
        _this.pageData.submitLoad = false
        _this.pageData.fullScreenLoad = false
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_servererr'),
        })
        return
      }, 2000)
    })
}

function queryFeedbackQuestion(_this) {
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/queryFeedbackQuestion',
      url: Vue.prototype.api + 'api/local/queryFeedbackQuestion',
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          _this.pageData.questionList = response.data.data

          let satisfied = []
          let satisfiedObj0 = {}
          let satisfiedObj1 = {}
          let satisfiedObj2 = {}
          let satisfiedObj3 = {}
          let satisfiedObj4 = {}
          satisfiedObj0.context = 'Very satisfied'
          satisfiedObj0.score = 10
          satisfiedObj1.context = 'Somewhat satisfied'
          satisfiedObj1.score = 8
          satisfiedObj2.context = 'Neither satisfied nor dissatisfied'
          satisfiedObj2.score = 6
          satisfiedObj3.context = 'Somewhat dissatisfied'
          satisfiedObj3.score = 4
          satisfiedObj4.context = 'Very dissatisfied'
          satisfiedObj4.score = 2

          satisfied.push(satisfiedObj0)
          satisfied.push(satisfiedObj1)
          satisfied.push(satisfiedObj2)
          satisfied.push(satisfiedObj3)
          satisfied.push(satisfiedObj4)

          _this.pageData.questionList[1].items = JSON.parse(
            JSON.stringify(satisfied)
          )
          _this.pageData.questionList[8].items = JSON.parse(
            JSON.stringify(satisfied)
          )
          _this.pageData.questionList[9].items = JSON.parse(
            JSON.stringify(satisfied)
          )

          let well = []
          let wellObj0 = {}
          let wellObj1 = {}
          let wellObj2 = {}
          let wellObj3 = {}
          let wellObj4 = {}
          wellObj0.context = 'Extremely well'
          wellObj0.score = 10
          wellObj1.context = 'Very well'
          wellObj1.score = 8
          wellObj2.context = 'Somewhat well'
          wellObj2.score = 6
          wellObj3.context = 'Not so well'
          wellObj3.score = 4
          wellObj4.context = 'Not at all well'
          wellObj4.score = 2

          well.push(wellObj0)
          well.push(wellObj1)
          well.push(wellObj2)
          well.push(wellObj3)
          well.push(wellObj4)

          _this.pageData.questionList[3].items = JSON.parse(
            JSON.stringify(well)
          )
          _this.pageData.questionList[7].items = JSON.parse(
            JSON.stringify(well)
          )

          let quality = []
          let qualityObj0 = {}
          let qualityObj1 = {}
          let qualityObj2 = {}
          let qualityObj3 = {}
          let qualityObj4 = {}
          qualityObj0.context = 'Very high quality'
          qualityObj0.score = 10
          qualityObj1.context = 'High quality'
          qualityObj1.score = 8
          qualityObj2.context = 'Neither high nor low quality'
          qualityObj2.score = 6
          qualityObj3.context = 'Low quality'
          qualityObj3.score = 4
          qualityObj4.context = 'Very low quality'
          qualityObj4.score = 2

          quality.push(qualityObj0)
          quality.push(qualityObj1)
          quality.push(qualityObj2)
          quality.push(qualityObj3)
          quality.push(qualityObj4)

          _this.pageData.questionList[4].items = JSON.parse(
            JSON.stringify(quality)
          )

          let rate = []
          let rateObj0 = {}
          let rateObj1 = {}
          let rateObj2 = {}
          let rateObj3 = {}
          let rateObj4 = {}
          rateObj0.context = 'Excellent'
          rateObj0.score = 10
          rateObj1.context = 'Above average'
          rateObj1.score = 8
          rateObj2.context = 'Average'
          rateObj2.score = 6
          rateObj3.context = 'Below average'
          rateObj3.score = 4
          rateObj4.context = 'Poor'
          rateObj4.score = 2

          rate.push(rateObj0)
          rate.push(rateObj1)
          rate.push(rateObj2)
          rate.push(rateObj3)
          rate.push(rateObj4)

          _this.pageData.questionList[5].items = JSON.parse(
            JSON.stringify(rate)
          )

          let responsive = []
          let responsiveObj0 = {}
          let responsiveObj1 = {}
          let responsiveObj2 = {}
          let responsiveObj3 = {}
          let responsiveObj4 = {}
          responsiveObj0.context = 'Extremely responsive'
          responsiveObj0.score = 10
          responsiveObj1.context = 'Very responsive'
          responsiveObj1.score = 8
          responsiveObj2.context = 'Somewhat responsive'
          responsiveObj2.score = 6
          responsiveObj3.context = 'Not so responsive'
          responsiveObj3.score = 4
          responsiveObj4.context = 'Not at all responsive'
          responsiveObj4.score = 2

          responsive.push(responsiveObj0)
          responsive.push(responsiveObj1)
          responsive.push(responsiveObj2)
          responsive.push(responsiveObj3)
          responsive.push(responsiveObj4)

          _this.pageData.questionList[6].items = JSON.parse(
            JSON.stringify(responsive)
          )
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

function postToSaveQuestion(_this, surveyForm) {
  _this.pageData.submitQuestionsFlag = true

  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/submitSurvey',
      url: Vue.prototype.api + 'api/local/submitSurvey',
      data: surveyForm,
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          _this.pageData.custUserinfo.feedback = 1
          sessionStorage.removeItem(_this.pageData.username)
          sessionStorage.setItem(
            _this.pageData.username,
            JSON.stringify(_this.pageData.custUserinfo)
          )

          _this.pageData.submitQuestionsFlag = false
          _this.$notify.success({
            title: _this.$t('App.notify.title_nofity'),
            message: _this.$t('App.page.orderconfirm.notify_feedback_success'),
          })
          _this.pageData.feedbackDialogVisible = false
          return
        } else if (response.data.code == '290') {
          _this.pageData.custUserinfo.feedback == 1
          sessionStorage.removeItem(_this.pageData.username)
          sessionStorage.setItem(
            _this.pageData.username,
            JSON.stringify(_this.pageData.custUserinfo)
          )

          _this.pageData.submitQuestionsFlag = false
          _this.$notify.success({
            title: _this.$t('App.notify.title_nofity'),
            message: _this.$t('App.page.orderconfirm.notify_feedback_success'),
          })
          _this.pageData.feedbackDialogVisible = false
          return
        } else {
          _this.pageData.submitQuestionsFlag = false
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.pageData.submitQuestionsFlag = false
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.pageData.submitQuestionsFlag = false
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

import Vue from 'vue'
import * as cartjs from '@/assets/js/cart'

export {
  getShippingAddress,
  getReceiptAddress,
  addShippingAddress,
  addReceiptAddress,
  packDetails,
  verifyOrder,
  getModifiedList,
  orderSubmit,
  queryFeedbackQuestion,
  postToSaveQuestion,
  returnPromiseShippings,
  returnPromiseReceipts,
  quickOrdering,
}



// WEBPACK FOOTER //
// ./src/assets/js/orderconfirm.js